module.exports = __webpack_public_path__ + "static/media/n_icon_shouyimingxi@2x.fea9af81.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_shouyimingxi@2x.png
// module id = 1811
// module chunks = 0 1